import { render } from "./CrmTasksPanel.vue?vue&type=template&id=1987b5a4&scoped=true&ts=true&lang=pug"
import script from "./CrmTasksPanel.vue?vue&type=script&lang=ts"
export * from "./CrmTasksPanel.vue?vue&type=script&lang=ts"

import "./CrmTasksPanel.vue?vue&type=style&index=0&id=1987b5a4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1987b5a4"]])

export default __exports__